export default context => context.store.dispatch('nuxtClientInit', context);
